'use client';

import { Suspense } from 'react';

import { useIsWebview } from '@flipster/features/src/shared/webview';

const HideIfWebview = ({ children }: React.PropsWithChildren) => {
  const isWebview = useIsWebview();
  if (isWebview) return null;
  return children;
};

export default HideIfWebview;

export function hideIfWebview<Props>(Component: React.FC<Props>): React.FC<Props> {
  return (props) => {
    // oxlint-disable-next-line @typescript-eslint/no-explicit-any
    const component = <Component {...(props as any)} />;
    return (
      <Suspense fallback={component}>
        <HideIfWebview>{component}</HideIfWebview>
      </Suspense>
    );
  };
}
